import { UIApplication, UIApplicationDelegate, UISceneConfiguration, UISceneConnectionOptions, UIWindow } from "uikit";
import { UISceneSession } from "uikit";
import { BookingDesktopViewController } from "./scenes/BookingDesktopViewController";
import { DLDB } from "dldb";
import { MIOCoreIsPhone } from "mio-core";

export class AppDelegate implements UIApplicationDelegate
{
    window: UIWindow;

    dryRunCheck = true;

    applicationDidFinishLaunchingWithOptions( applicataion:UIApplication, options:any): boolean {

        DLDB.shared.options = options;

        let vc = new BookingDesktopViewController();
        vc.initWithNibName( MIOCoreIsPhone() ? "BookingMobileView" : "BookingDesktopView" );

        this.window = new UIWindow();
        this.window.initWithRootViewController( vc );

        return true;
    }    

    applicationConfigurationForConnectingSceneSession( application:UIApplication, connectingSceneSession:UISceneSession, options:UISceneConnectionOptions): UISceneConfiguration {
        return new UISceneConfiguration("Default Configuration", connectingSceneSession.role);
    }

    applicationDidDiscardSceneSessions(application:UIApplication, sceneSessions:Set<UISceneSession>) {

    }
  
}